import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

export default function ApplicationStatusPage() {
  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900 flex flex-col">
      <PublicHeader />

      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8">
        <Card className="max-w-md w-full">
          <CardHeader>
            <CardTitle>Check Application Status</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-slate-600">
            Online application status lookup isn't available yet.
          </CardContent>
        </Card>
      </main>

      <PublicFooter>Multi-Service Center &nbsp;·&nbsp; Energy Assistance</PublicFooter>
    </div>
  );
}
